import { faMapMarkerAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { SUBSCRIBER_TEST_IDS } from '../../../../config/constants/ppc';
import {
  SUBSCRIPTION_EMAIL_IS_REQUIRED,
  SUBSCRIPTION_LOCATION_IS_REQUIRED,
  KICKBOX_FAILED_VALIDATION,
  DID_YOU_MEAN,
} from '../../../../config/text/text';
import ThemeContext from '../../../../providers/ThemeProvider';
import Icon from '../../../Icon';
import Message from '../../../_generic/Message';
import BareSelect from '../../../_generic/form/BareSelect';

const InputDropdown = ({
  variant,
  email,
  changeEmail,
  locationAux,
  onChangeAction,
  showError,
  showErrorForLocation,
  showKickboxError,
  suggestedMail,
  updatedList,
}) => {
  const theme = useContext(ThemeContext);
  const { ERROR_TEXT, LOCATION_SELECT } = SUBSCRIBER_TEST_IDS;

  const isPinkBackground = variant === 'e';
  const errorColor = isPinkBackground
    ? '#fff'
    : theme.colors.lightboxredborders;

  const inputStyle = {
    backgroundColor:
      variant === 'b' || variant === 'c' ? theme.colors.primary : '#fff',
    border:
      variant === 'b'
        ? `1px solid grey`
        : variant === 'c' || variant === 'd'
        ? `1px solid ${theme.colors.primary}`
        : '1px solid #fff',
    borderRadius: '8px',
    color: variant === 'b' || variant === 'c' ? '#fff' : '#000',
    padding: '10px',
    paddingLeft: '35px',
    width: '100%',
  };

  return (
    <div className="container-input">
      <div className="input-wrapper">
        <div style={{ position: 'relative', width: '100%' }}>
          <div className="icon-wrapper">
            <Icon
              color={theme.colors.primary}
              faIcon={faMapMarkerAlt}
              size="24px"
            />
          </div>
          <BareSelect
            ariaLabel="subscribe-dropdown-welcome-page"
            dataTestId={LOCATION_SELECT}
            dataqa="selectLocation"
            extraClasses="subscribe-dropdown-welcome-page"
            formId="form_input_custom3"
            name="subscribe-dropdown-welcome-page"
            onChange={(event) => onChangeAction(event.target.value)}
            options={updatedList}
            style={inputStyle}
            value={locationAux}
          />
        </div>
        {showErrorForLocation && (
          <div className="error-message-welcom-page" data-testid={ERROR_TEXT}>
            {SUBSCRIPTION_LOCATION_IS_REQUIRED}
          </div>
        )}
      </div>

      <div className="input-wrapper">
        <div style={{ position: 'relative', width: '100%' }}>
          <div className="icon-wrapper">
            <Icon
              color={theme.colors.primary}
              faIcon={faEnvelope}
              size="24px"
            />
          </div>
          <input
            className="styled-input"
            data-testid={SUBSCRIBER_TEST_IDS.EMAIL_INPUT}
            onChange={(e) => changeEmail(e)}
            placeholder="Enter your email address"
            theme={theme}
            type="email"
            value={email}
            variant={variant}
          />
        </div>
        {showError && (
          <div className="error-message-welcom-page" data-testid={ERROR_TEXT}>
            {SUBSCRIPTION_EMAIL_IS_REQUIRED}
          </div>
        )}
        {showKickboxError && (
          <div className="error-message-welcom-page" data-testid={ERROR_TEXT}>
            {KICKBOX_FAILED_VALIDATION}
          </div>
        )}
        {suggestedMail && suggestedMail.length > 0 && (
          <Message
            iconPosition="left"
            message={`${DID_YOU_MEAN} ${suggestedMail}`}
            style={{ color: errorColor, marginTop: '5px', textAlign: 'center' }}
          />
        )}
      </div>
      <style jsx>{`
        :global(.subscribe-dropdown-welcome-page) {
          border-radius: ${variant === 'b' ? '14px' : '50px'};
          padding: 15px;
          position: relative;
          width: -webkit-fill-available;
          font-size: 16px;
          border: ${variant === 'b' || variant === 'f'
            ? `2px solid #cbcbcb `
            : variant === 'c' || variant === 'd'
            ? `2px solid ${theme.colors.primary} `
            : '2px solid #fff '};
          color: ${variant === 'c' || variant === 'd' ? '#7c7c7c' : '#757575'};
          padding-left: 60px;
          height: auto;
          margin: 16px auto;
          outline: none;
          background: linear-gradient(45deg, transparent 50%, #7c7c7c 50%),
            linear-gradient(135deg, #7c7c7c 50%, transparent 50%),
            linear-gradient(to right, transparent, transparent);
          background-position: calc(99% - 21px) calc(1.4em + 2px),
            calc(99% - 16px) calc(1.4em + 2px), 100% 0;
          background-size: 5px 5px, 5px 5px, 2.5em 2.5em;
          background-repeat: no-repeat;
          -webkit-box-sizing: border-box;
          -moz-box-sizing: border-box;
          box-sizing: border-box;
          -webkit-appearance: none;
          -moz-appearance: none;
          background-color: ${variant === 'c' || variant === 'd'
            ? '#FFEBF7'
            : '#fff '};
        }

        :global(.container-input) {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 5%;
          width: 70%;
          animation: fadeUp 1s ease-out;
          margin-top: 16px;
        }

        @keyframes fadeUp {
          0% {
            opacity: 0;
            transform: translateY(20px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
        :global(.input-wrapper) {
          position: relative;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        :global(.styled-input) {
          flex-direction: column;
          border-radius: ${variant === 'b' ? '14px' : '50px'};
          padding: 16px;
          width: -webkit-fill-available;
          font-size: 16px;
          border: ${variant === 'b' || variant === 'f'
            ? `2px solid #cbcbcb`
            : variant === 'c' || variant === 'd'
            ? `2px solid ${theme.colors.primary}`
            : '2px solid #fff'};
          background-color: ${variant === 'c' || variant === 'd'
            ? '#FFEBF7'
            : '#fff'};
          color: ${variant === 'c' || variant === 'd' ? '#7c7c7c' : '#000'};
          padding-left: 62px;
          outline: none;
          margin: 16px auto;
        }

        :global(.icon-wrapper) {
          position: absolute;
          left: 22px;
          top: 50%;
          transform: translateY(-50%);
          z-index: 1;
          pointer-events: none;
        }
        :global(.error-message-welcom-page) {
          color: ${errorColor};
          font-size: 14px;
          margin-top: -10px;
          width: 100%;
        }
        @media only screen and (max-width: ${theme.breakpoints.mdUp}) {
          :global(.container-input) {
            flex-direction: column;
            width: 90%;
          }
        }
      `}</style>
    </div>
  );
};

InputDropdown.propTypes = {
  changeEmail: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  locationAux: PropTypes.string.isRequired,
  onChangeAction: PropTypes.func.isRequired,
  showError: PropTypes.bool.isRequired,
  showErrorForLocation: PropTypes.bool.isRequired,
  showKickboxError: PropTypes.bool.isRequired,
  suggestedMail: PropTypes.string,
  updatedList: PropTypes.arrayOf(PropTypes.any).isRequired,
  variant: PropTypes.oneOf(['b', 'c', 'd', 'e', 'f']).isRequired,
};

export default InputDropdown;
